import React from 'react';
import PropTypes from 'prop-types';

import {ActivityIndicator} from 'components/ActivityIndicator';

import {I18n} from '@aws-amplify/core';

import {Grid, GridItem} from 'pac-ux-components';

const CancelLink = () => (
    <a
        onClick={() => {
            window.location.assign('/');
        }}
    >
        {I18n.get('Cancel')}
    </a>
);

const label = ['Authorizing', 'Please wait']
    .map((item) => I18n.get(item))
    .join('...');

const AuthorizingIndicator = () => {
    return (
        <React.Fragment>
            <Grid columns="60% 40%">
                <GridItem>
                    <ActivityIndicator label={label} />
                </GridItem>
                <GridItem>
                    <Grid paddingTop="20%" justifyItems="center" gap="2px">
                        <CancelLink />
                    </Grid>
                </GridItem>
            </Grid>
        </React.Fragment>
    );
};

AuthorizingIndicator.propTypes = {
    accounts: PropTypes.array,
};

export default AuthorizingIndicator;

export { AuthorizingIndicator };
